import styled from "styled-components";

interface StepProgressProps {
  totalSteps: number;
  currentStep: number;
}

const Circle = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 50;
`;

const Wrapper = styled.div`
  position: relative;
`;

const Line = styled.div`
  position: absolute;
  width: 100%;
  height: 2px;
  top: 50%;
  z-index: 10;
`;

const StepProgress = ({ totalSteps, currentStep }: StepProgressProps) => {
  // build steps from totalsteps
  const steps = Array.from({ length: totalSteps }, (_, i) => i);

  return (
    <Wrapper>
      <Line className="bg-secondary" />
      <div className="w-100 d-flex flex-row justify-content-between my-4">
        {steps.map((step, index) => (
          <Circle
            key={index}
            className={`circle ${
              index <= currentStep ? "bg-tertiary" : "bg-secondary"
            }`}
          >
            {index + 1}
          </Circle>
        ))}
      </div>
    </Wrapper>
  );
};

export default StepProgress;
